import { render, staticRenderFns } from "./realistic.vue?vue&type=template&id=03becf7c&scoped=true&"
import script from "./realistic.vue?vue&type=script&lang=js&"
export * from "./realistic.vue?vue&type=script&lang=js&"
import style0 from "./realistic.vue?vue&type=style&index=0&id=03becf7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03becf7c",
  null
  
)

export default component.exports